/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [

]

export const labNavigation: FuseNavigationItem[] = [
    {
        id: 'laboratory',
        title: 'Laboratorio',
        type: 'group',
        icon: 'mat_outline:science',
        children: [
            {
                id: 'laboratory.exams_tests',
                title: 'Exámenes',
                type: 'basic',
                link: 'examenes',
                icon: 'mat_outline:format_list_bulleted',
            }, {
                id: 'laboratory.exams_types',
                title: 'Pruebas',
                type: 'basic',
                link: 'pruebas',
                icon: 'mat_outline:assignment',
            }
        ],
    }
]

export const rxNavigation: FuseNavigationItem[] = [
    {
        id: 'rx',
        title: 'Rayos X',
        type: 'basic',
        link: 'rayos-x',
        icon: 'feather:radio',
    },
    {
        id: 'appointment',
        title: 'Agendas',
        type: 'basic',
        link: 'agendas',
        icon: 'mat_outline:calendar_today',
    }
]

export const receptionistNavigation: FuseNavigationItem[] = [
    {
        id: 'admin',
        title: 'Administración',
        type: 'group',
        icon: 'mat_outline:admin_panel_settings',
        children: [
            {
                id: 'admin.users',
                title: 'Usuarios',
                type: 'basic',
                link: 'usuarios',
                icon: 'heroicons_outline:users',
            },
            {
                id: 'admin.agreements',
                title: 'Convenios',
                type: 'basic',
                link: 'convenios',
                icon: 'heroicons_outline:document-text',
            }

        ]
    },
    {
        id: 'clinic',
        title: 'Clínica',
        type: 'group',
        icon: 'mat_outline:local_hospital',
        children: [
            {
                id: 'clinic.specialties',
                title: 'Especialidades',
                type: 'basic',
                link: 'especialidades',
                icon: 'mat_outline:medication',
            }, {
                id: 'clinic.specialists',
                title: 'Especialistas',
                type: 'basic',
                link: 'especialistas',
                icon: 'mat_outline:medical_services',
            }, {
                id: 'clinic.patients',
                title: 'Pacientes',
                type: 'basic',
                link: 'pacientes',
                icon: 'mat_outline:accessibility_new',
            }
        ]
    },
    {
        id: 'laboratory',
        title: 'Laboratorio',
        type: 'group',
        icon: 'mat_outline:science',
        children: [
            {
                id: 'laboratory.exams_types',
                title: 'Pruebas',
                type: 'basic',
                link: 'pruebas',
                icon: 'mat_outline:assignment',
            }
        ],
    },
    {
        id: 'appointment',
        title: 'Agendas',
        type: 'basic',
        link: 'agendas',
        icon: 'mat_outline:calendar_today',
    },
    {
        id: 'reports',
        title: 'Reportes',
        type: 'group',
        icon: 'mat_outline:description',
        children: [
            {
                id: 'reports.templates',
                title: 'Machotes',
                type: 'basic',
                link: 'plantillas-reportes',
                icon: 'mat_outline:content_paste',
            },
            {
                id: 'reports.medical_reports',
                title: 'Reportes Médicos',
                type: 'basic',
                link: 'reportes-medicos',
                icon: 'feather:file-text',
            },
        ],
    },    
]

export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'admin',
        title: 'Administración',
        type: 'group',
        icon: 'mat_outline:admin_panel_settings',
        children: [
            {
                id: 'admin.users',
                title: 'Usuarios',
                type: 'basic',
                link: 'usuarios',
                icon: 'heroicons_outline:users',
            },
            {
                id: 'admin.agreements',
                title: 'Convenios',
                type: 'basic',
                link: 'convenios',
                icon: 'heroicons_outline:document-text',
            },
            {
                id: 'admin.reception',
                title: 'Dashboard Recepción',
                type: 'basic',
                link: 'dashboard/recepcion',
                icon: 'mat_outline:headset_mic',
            }
        ]
    },
    {
        id: 'clinic',
        title: 'Clínica',
        type: 'group',
        icon: 'mat_outline:local_hospital',
        children: [
            {
                id: 'clinic.specialties',
                title: 'Especialidades',
                type: 'basic',
                link: 'especialidades',
                icon: 'mat_outline:medication',
            }, {
                id: 'clinic.specialists',
                title: 'Especialistas',
                type: 'basic',
                link: 'especialistas',
                icon: 'mat_outline:medical_services',
            }, {
                id: 'clinic.patients',
                title: 'Pacientes',
                type: 'basic',
                link: 'pacientes',
                icon: 'mat_outline:accessibility_new',
            }
        ]
    },
    {
        id: 'laboratory',
        title: 'Laboratorio',
        type: 'group',
        icon: 'mat_outline:science',
        children: [
            {
                id: 'laboratory.exams_tests',
                title: 'Exámenes',
                type: 'basic',
                link: 'examenes',
                icon: 'mat_outline:format_list_bulleted',
            }, {
                id: 'laboratory.exams_types',
                title: 'Pruebas',
                type: 'basic',
                link: 'pruebas',
                icon: 'mat_outline:assignment',
            }
        ],
    },
    {
        id: 'rx',
        title: 'Rayos X',
        type: 'basic',
        link: 'rayos-x',
        icon: 'feather:radio',
    },
    {
        id: 'appointment',
        title: 'Agendas',
        type: 'basic',
        link: 'agendas',
        icon: 'mat_outline:calendar_today',
    },
    {
        id: 'reports',
        title: 'Reportes',
        type: 'group',
        icon: 'mat_outline:description',
        children: [
            {
                id: 'reports.templates',
                title: 'Machotes',
                type: 'basic',
                link: 'plantillas-reportes',
                icon: 'mat_outline:content_paste',
            },
            {
                id: 'reports.medical_reports',
                title: 'Reportes Médicos',
                type: 'basic',
                link: 'reportes-medicos',
                icon: 'feather:file-text',
            },
        ],
    },
]

